import {
    Box,
    Container,
    Typography,
    Paper,
    ThemeProvider,
} from "@mui/material";
import { darkTheme } from "../../theme/darkTheme";
import LoadingNavBarBot from "./LoadingNavBarBot";
import NavBar from "./NavBar";

const LoadingPage = () => {
    return (
        <>
            <ThemeProvider theme={darkTheme}>
                <Box
                    sx={{
                        minHeight: "100vh",
                        background: `
                            radial-gradient(circle at top left, rgba(25,118,210,0.15), transparent 40%),
                            radial-gradient(circle at bottom right, rgba(156,39,176,0.15), transparent 40%),
                            background.default
                        `,
                    }}
                >
                    <NavBar />

                    <Container
                        maxWidth="lg"
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: "calc(100vh - 80px)",
                        }}
                    >
                        <Paper
                            elevation={0}
                            sx={{
                                px: 6,
                                py: 5,
                                borderRadius: 4,
                                textAlign: "center",
                                backdropFilter: "blur(16px)",
                                background:
                                    "rgba(255,255,255,0.05)",
                                border:
                                    "1px solid rgba(255,255,255,0.08)",
                                minWidth: 320,
                            }}
                        >
                            <Box
                                component="img"
                                src="/loading.gif"
                                alt="Loading"
                                sx={{
                                    width: 120,
                                    height: 120,
                                    objectFit: "contain",
                                }}
                            />

                            <Typography
                                variant="h5"
                                sx={{ mt: 2, fontWeight: 700 }}
                            >
                                Lädt...
                            </Typography>

                        </Paper>
                    </Container>
                </Box>
            </ThemeProvider>

            <LoadingNavBarBot />
        </>
    );
};

export default LoadingPage;